import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';

import { Header } from './../_common/header';

export const SettingsPaiement = () => {
	const user = useSelector(state => state.user);
	const [passwordRequirements, setPasswordRequirements] = useState({ hasLower: false, hasUpper: false, hasDigits: false });
	const [credentials, setCredentials] = useState({
		email: !R.isNil(user.user) && !R.isNil(user.user.email) ? user.user.email : '',
		password: '',
		confirmPassword: ''
	});
	const credentialsForm = useRef(null);
	const [wasValidated, setWasValidated] = useState(false);

	return (
		<article className="view-calc pt-6 mb-auto pb-sm">
			<Header />
			<div className="auto-view h-100 mb-auto">
				<div className="container-fluid">
					<div className="grid grid-sm-min grid-lg-narrow grid-hd-auto">
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Zdenek Croquetaigne</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">Audric Goddu</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-alert-success"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-success h6 my-auto text-uppercase lh-solid"} role="progressbar">payé</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Marmion De La Ronde</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-none"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid o-40"} role="progressbar">en attente de paiement</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Vick Poisson</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-alert-success"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-success h6 my-auto text-uppercase lh-solid"} role="progressbar">payé</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Peverell Arnoux</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-alert-success"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-success h6 my-auto text-uppercase lh-solid"} role="progressbar">payé</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Hilaire Marier</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-alert-success"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-success h6 my-auto text-uppercase lh-solid"} role="progressbar">payé</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Vedette Sorel</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-none"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid o-40"} role="progressbar">en attente de paiement</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Mathilde Jolicoeur</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-none"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid o-40"} role="progressbar">en attente de paiement</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Antoine Faucher</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-none"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid o-40"} role="progressbar">en attente de paiement</div>
								</div>
							</div>
						</div><div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Zdenek Croquetaigne</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">Audric Goddu</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-alert-success"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-success h6 my-auto text-uppercase lh-solid"} role="progressbar">payé</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Marmion De La Ronde</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-alert-success"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-success h6 my-auto text-uppercase lh-solid"} role="progressbar">payé</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Vick Poisson</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-alert-success"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-success h6 my-auto text-uppercase lh-solid"} role="progressbar">payé</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Peverell Arnoux</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-alert-success"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-success h6 my-auto text-uppercase lh-solid"} role="progressbar">payé</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Clementine Laframouenr</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-alert-success"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-success h6 my-auto text-uppercase lh-solid"} role="progressbar">payé</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Zoé Latourelle</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-none"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid o-40"} role="progressbar">en attente de paiement</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Anouk Poirier</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-none"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid o-40"} role="progressbar">en attente de paiement</div>
								</div>
							</div>
						</div>
						<div className="card text-center h-100 rounded">
							<div className="card-body my-auto px-3">
								<h4 className="h3 ls-n1 font-weight-black my-auto">Christine Bourgeau</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mt-2 mb-0">reglé en interne</p>
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit bg-none"} style={{ width: `100%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid o-40"} role="progressbar">en attente de paiement</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</article>
	)
};